import emitAsync from '../utils/emitAsync';
import { useLoadingStore } from '../stores/useLoadingStore';
import { useSocketStore } from '../stores/useSocketStore';

// =========================
// REQUESTS ATIVAS
// =========================

export const CLIENTS_RETRY_DELAY = 3000;

const activeRequests = new Set();

// =========================
// LOAD CLIENTS
// =========================

const {
    setLoadingClients,
    setLoadingFooter,
    setLoadingFooterTxt,
    setLoadProgress
} = useLoadingStore.getState();

export async function loadClients(socket) {

    if (!socket?.connected) {
        return false;
    }

    const requestId =
        crypto.randomUUID();

    activeRequests.add(
        requestId
    );

    try {

        // =========================
        // LOADING
        // =========================

        setLoadingClients(true);

        setLoadingFooter(true);

        setLoadingFooterTxt('Carregando clientes...');

        setLoadProgress(0);

        // =========================
        // REQUEST
        // =========================

        await emitAsync(
            socket,
            'clientes:get',
            {
                requestId
            }
        );

        return true;

    } catch (err) {

        console.error(
            'Erro ao iniciar carregamento de clientes:',
            err
        );

        finishClientsRequest(requestId, false);

        if (socket?.connected) {

            setTimeout(() => {

                const {
                    connectionReady
                } = useSocketStore.getState();

                if (
                    socket?.connected &&
                    connectionReady
                ) {
                    loadClients(socket);
                }

            }, CLIENTS_RETRY_DELAY);

        }

        return false;

    }

}

// =========================
// REQUEST ATIVA
// =========================

export function isClientsRequestActive(
    requestId
) {

    return activeRequests.has(
        requestId
    );

}

// =========================
// FINALIZA REQUEST
// =========================

export function finishClientsRequest(
    requestId,
    stopLoading = true
) {

    activeRequests.delete(requestId);

    // Ainda existe outra carga
    // de clientes em andamento
    if (activeRequests.size > 0) {
        return;
    }

    if(stopLoading) {
        setLoadingClients(false);

        setLoadingFooter(false);

        setLoadingFooterTxt('Carregando...');
    }    

    setLoadProgress(100);

}

// =========================
// LIMPA REQUESTS
// =========================

export function clearClientsRequests() {

    activeRequests.clear();

    setLoadingClients(false);

    setLoadingFooter(false);

    setLoadingFooterTxt('Carregando...');

    setLoadProgress(100);

}